<app-loader *ngIf="loading"></app-loader>


<div class="divCustomGlobal">
  <div class="divCustomSection">
    <i class='fas fa-book mr-2'></i> Información
  </div>
  <!--PESTAÑA INFORMACION-->
  <div style="margin: 10px;">
    <form [formGroup]="formEmployee">
      <div class="row mt-2">
        <div class="col-lg">
          <div class="md-form md-outline">
            <input mdbInput type="text" id="identification_document" formControlName="identification_document" class="form-control form-control-sm" placeholder="">
            <label for="identification_document" class="">NIF</label>
          </div>
        </div>
        <div class="col-lg">
          <div class="md-form md-outline">
            <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="employeename" formControlName="name" class="form-control form-control-sm" placeholder="">
            <label for="employeename" class="">Nombre</label>
            <mdb-error *ngIf="!formEmployee.controls.name.valid && (formEmployee.controls.name.dirty || formEmployee.controls.name.touched)">Campo obligatorio</mdb-error>
          </div>
        </div>
        <div class="col-lg">
          <div class="md-form md-outline">
            <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="employeesurname" formControlName="surname" class="form-control form-control-sm"  placeholder="">
            <label for="employeesurname" class="">Apellidos</label>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-lg">
          <div class="md-form md-outline">
            <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="email" formControlName="email" class="form-control form-control-sm" placeholder="">
            <label for="email" class="">Email</label>
            <mdb-error *ngIf="formEmployee.controls.email.invalid && (formEmployee.controls.email.dirty || formEmployee.controls.email.touched)">Introduce un email válido</mdb-error>
          </div>
        </div>
        <div class="col-lg">
          <div class="md-form md-outline">
            <input mdbInput type="text" id="employeephone" formControlName="phone" class="form-control form-control-sm"  placeholder="">
            <label for="employeephone" class="">Teléfono</label>
          </div>
        </div>
        <div class="col-lg">
          <div class="md-form md-outline">
            <input mdbInput type="text" id="employeemobile" formControlName="mobile" class="form-control form-control-sm"  placeholder="">
            <label for="employeemobile" class="">Móvil</label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <div class="md-form md-outline">
            <input mdbInput type="text" id="employeeaddress" formControlName="address" class="form-control form-control-sm" placeholder="">
            <label for="employeeaddress" class="">Dirección</label>
          </div>
        </div>
        <div class="col-4">
          <div class="md-form md-outline">
            <input mdbInput type="text" id="employeeprovince" formControlName="province" class="form-control form-control-sm" placeholder="">
            <label for="employeeprovince" class="">Provincia</label>
          </div>
        </div>
        <div class="col-lg">
          <div class="md-form md-outline">
            <input mdbInput type="text" id="employeepopulation" formControlName="population" class="form-control form-control-sm" placeholder="">
            <label for="employeepopulation" class="">Población</label>
          </div>
        </div>
        <div class="col-lg">
          <div class="md-form md-outline">
            <input mdbInput type="text" id="employeepostalcode" formControlName="postal_code" class="form-control form-control-sm" placeholder="">
            <label for="employeepostalcode" class="">Código Postal</label>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="divCustomSection">
    <i class='fas fa-toolbox mr-2'></i> Gremios
  </div>
  <!--PESTAÑA gremios-->
  <div style="margin: 10px;">
    <app-employee-guilds #guildsComponent [all_guilds]="dropdowndata?.guild" (guildsChanged)="tab.modifiedData = true"></app-employee-guilds>
  </div>
</div>

<!--
<div class="container-fluid pt-2">
  <form [formGroup]="formEmployee">
    <div class="row">
      <div class="col-12 custom-card-padding">
        <mdb-tabset [buttonClass]="'md-tabs pills-primary white mb-2'" [contentClass]="'card'">
          <mdb-tab [heading]="heading">
            <div class="row">
              <div class="col-lg-2">
                  <div class="md-form">
                      <input mdbInput type="text" id="identification_document"
                          formControlName="identification_document" class="form-control form-control-sm" placeholder="">
                      <label for="identification_document" class="">NIF</label>
                  </div>
              </div>
              <div class="col-lg">
                  <div class="md-form">
                      <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="clientname"
                          formControlName="name" class="form-control form-control-sm" placeholder="">
                      <label for="clientname" class="">Nombre</label>
                      <mdb-error
                          *ngIf="!formEmployee.controls.name.valid && (formEmployee.controls.name.dirty || formEmployee.controls.name.touched)">
                          Campo obligatorio</mdb-error>
                  </div>
              </div>
              <div class="col-lg">
                  <div class="md-form">
                      <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="clientsurname"
                          formControlName="surname" class="form-control form-control-sm"  placeholder="">
                      <label for="clientsurname" class="">Apellidos</label>
                  </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg">
                <div class="md-form">
                  <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="email" formControlName="email"
                    class="form-control form-control-sm" placeholder="">
                  <label for="email" class="">Email</label>
                  <mdb-error
                    *ngIf="formEmployee.controls.email.invalid && (formEmployee.controls.email.dirty || formEmployee.controls.email.touched)">
                    Introduce un email válido</mdb-error>
                </div>
              </div>
              <div class="col-lg">
                  <div class="md-form">
                      <input mdbInput type="text" id="clientphone"
                          formControlName="phone" class="form-control form-control-sm"  placeholder="">
                      <label for="clientphone" class="">Teléfono</label>
                  </div>
              </div>
              <div class="col-lg">
                  <div class="md-form">
                      <input mdbInput type="text" id="clientmobile"
                          formControlName="mobile" class="form-control form-control-sm"  placeholder="">
                      <label for="clientmobile" class="">Móvil</label>
                  </div>
              </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <mdb-card class="z-depth-0">
                <mdb-card-header class="blue-grey-text white border-bottom border-primary">
                    <mdb-icon fad icon="home-alt" size="lg" class="mr-1 text-primary"></mdb-icon>Dirección
                </mdb-card-header>
                <mdb-card-body>
                  <div class="row">
                    <div class="col-lg">
                      <div class="md-form">
                        <input mdbInput type="text" id="address" formControlName="address"
                          class="form-control form-control-sm" placeholder="">
                        <label for="address" class="">Dirección</label>
                      </div>
                    </div>

                    <div class="col-lg">
                      <div class="md-form">
                        <input mdbInput type="text" id="population" formControlName="population"
                          class="form-control form-control-sm" placeholder="">
                        <label for="population" class="">Población</label>
                      </div>
                    </div>
                    <div class="col-lg">
                      <div class="md-form">
                        <input mdbInput type="text" id="province" formControlName="province"
                          class="form-control form-control-sm" placeholder="">
                        <label for="province" class="">Provincia</label>
                      </div>
                    </div>
                    <div class="col-lg-2 col-xl-1">
                      <div class="md-form">
                        <input mdbInput type="text" id="postalcode" formControlName="postal_code"
                          class="form-control form-control-sm" placeholder="">
                        <label for="postalcode" class="">Código Postal</label>
                      </div>
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <app-employee-guilds #guildsComponent [all_guilds]="dropdowndata?.guild" (guildsChanged)="tab.modifiedData = true"></app-employee-guilds>
            </div>
          </div>
          </mdb-tab>
        </mdb-tabset>
      </div>
    </div>
  </form>
</div>
<!-- <div class="container-fluid pt-2">

  <form [formGroup]="formEmployee">
    <mdb-tabset [buttonClass]="'pills-default white mb-2'" [contentClass]="'card'">
      <mdb-tab [heading]="heading">
        <div class="row">
          <div class="col-lg">
            <div class="md-form">
              <input mdbInput type="text" id="identification_document" formControlName="identification_document"
                class="form-control form-control-sm">
              <label for="identification_document" class="">NIF</label>
            </div>
          </div>
          <div class="col-lg">
            <div class="md-form">
              <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="name" formControlName="name" class="form-control form-control-sm">
              <label for="name" class="">Nombre</label>
              <mdb-error
              *ngIf="formEmployee.controls.name.invalid && (formEmployee.controls.name.dirty || formEmployee.controls.name.touched)">
              No puedes dejar este campo vacío
            </mdb-error>
            </div>
          </div>
          <div class="col-lg">
            <div class="md-form">
              <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="surname"
                formControlName="surname" class="form-control form-control-sm">
              <label for="surname" class="">Apellidos</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg">
            <div class="md-form">
              <input mdbInput type="text" id="address" formControlName="address"
                class="form-control form-control-sm">
              <label for="address" class="">Dirección</label>
            </div>
          </div>

          <div class="col-lg">
            <div class="md-form">
              <input mdbInput type="text" id="population" formControlName="population"
                class="form-control form-control-sm">
              <label for="population" class="">Población</label>
            </div>
          </div>
          <div class="col-lg">
            <div class="md-form">
              <input mdbInput type="text" id="province" formControlName="province"
                class="form-control form-control-sm">
              <label for="province" class="">Provincia</label>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="md-form">
              <input mdbInput type="text" id="postalcode" formControlName="postal_code"
                class="form-control form-control-sm">
              <label for="postalcode" class="">Código Postal</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-3">
            <div class="md-form">
              <input mdbInput type="text" id="phone" formControlName="phone" class="form-control form-control-sm">
              <label for="phone" class="">Teléfono</label>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="md-form">
              <input mdbInput type="text" id="mobile" formControlName="mobile"
                class="form-control form-control-sm">
              <label for="mobile" class="">Móvil</label>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="md-form">
              <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="email" formControlName="email"
                class="form-control form-control-sm">
              <label for="email" class="">Email</label>
              <mdb-error *ngIf="formEmployee.controls.email.invalid && formEmployee.controls.email.errors.data_exists">El
                email introducido ya está en uso</mdb-error>
              <mdb-error
                *ngIf="formEmployee.controls.email.invalid && (formEmployee.controls.email.dirty || formEmployee.controls.email.touched)">
                Introduce un email válido</mdb-error>
            </div>
          </div>
        </div>
      </mdb-tab>
    </mdb-tabset>
  </form>
</div>
 -->
